<template>
  <ListSelect
    v-model="value"
    :options="knownEmployeeSelectables"
    :loading="knownEmployeeSelectablesLoading"
    :quick-sums="employeeQuickSums"
    :quick-sums-loading="employeeQuickSumsLoading"
    :customLabel="getEmployeeLabel"
    :filter-quick-sums-input="filterQuickSumsByEmployeeSelection"
    @filterQuickSumsBySelectionChange="onFilterQuickSumsBySelectionChange"
    trace-by="id"
  >
    <template v-slot:noData>
      <p class="text-xs-center">
        Keine Mitarbeiter.
      </p>
      <p class="text-xs-center">
        <router-link :to="{name: 'employees'}">
          Mitarbeiter anlegen
        </router-link>
      </p>
    </template>
  </ListSelect>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { api, endpoints } from '@/api'

import ListSelect from '@/components/ListSelect'
import {getEmployeeLabel} from '../filters/Employee'

export default {
  components: {
    ListSelect,
  },
  data () {
    return {}
  },
  computed: {
    value: {
      get () {
        return this.selectedEmployees
      },
      set (value) {
        this.updateSelectedEmployees({employees: [...value]})
      }
    },
    ...mapGetters([
      'selectedEmployees',
      'knownEmployeeSelectables',
      'knownEmployeeSelectablesLoading',
      'employeeQuickSums',
      'employeeQuickSumsLoading',
      'filterQuickSumsByEmployeeSelection'
    ]),
  },
  methods: {
    getEmployeeLabel: getEmployeeLabel,
    onFilterQuickSumsBySelectionChange (value) {
      this.updateFilterQuickSumsByEmployeeSelection({value})
      this.$root.$emit("refreshQuickSums", "employee")
    },
    ...mapActions([
      'updateSelectedEmployees',
      'updateFilterQuickSumsByEmployeeSelection',
    ]),
  }
}
</script>
